<template>
	<div>
		<c-dialog ref="pay" title="收款" height="75vh" :button="auth('b_app_order_offline_collect')" @close="closeHandle">
			<div class="pay">
				<div class="pay-sum flex-center">
					<span>付款金额：</span>
					<strong>￥{{sum}}</strong>
				</div>
				<c-form ref="form">
					<c-form-item label="选择收款方式" required>
						<c-radio-group v-model="currentPayMode" :options="payModeOptions"></c-radio-group>
					</c-form-item>
					<template v-if="currentPayMode == 'offline'">
						<c-form-item label="类型" required>
							<c-radio-group v-model="currentOfflinePayType" :options="offlinePayTypeOptions"></c-radio-group>
						</c-form-item>
						<template v-if="currentOfflinePayType == 'offline_bank_card'">
							<c-form-item label="转账信息">
								<div class="pay-account">
									<p><label>开户银行：</label>{{payInfo.offline_pay_config.bank_name || '-'}}</p>
									<p><label>账户名称：</label>{{payInfo.offline_pay_config.bank_account_name || '-'}}</p>
									<p><label>银行账号：</label>{{payInfo.offline_pay_config.bank_account_no || '-'}}</p>
								</div>
							</c-form-item>
						</template>
						<c-form-item label="付款凭证">
							<c-upload-file name="pay_voucher_url" type="image" media :side="false" filePath="quote"></c-upload-file>
						</c-form-item>
						<c-form-item label="备注">
							<c-input name="remark" type="textarea"></c-input>
						</c-form-item>
						<template v-if="currentOfflinePayType == 'offline_qr_code'">
							<a style="display: inline-block; padding: .2rem 0; font-size: .28rem; text-decoration: underline; color: #666;" @click="$refs.payCode.open();">显示收款码↘</a>
						</template>
					</template>
					<template v-else-if="currentPayMode == 'online'">
						<c-form-item label="类型" required>
							<c-radio-group v-model="currentOnlinePayType" :options="onlinePayTypeOptions"></c-radio-group>
						</c-form-item>
						<div class="pay-code flex-center">
							<c-qrcode v-if="onlinePayCode" :value="onlinePayCode" size="4.8" margin="0.3" style="border-radius: .12rem;"></c-qrcode>
						</div>
						<p class="pay-code-tip">请买方客户扫码付款</p>
					</template>
				</c-form>
			</div>

			<template #button>
				<c-button size="dialog" @click="$refs.pay.close(); closeHandle();">取消</c-button>
				<c-button v-if="currentPayMode == 'offline'" size="dialog" color="main" @click="submitHandle">确认已收款</c-button>
			</template>
		</c-dialog>

		<c-dialog ref="payCode" title="收款码" :button="false" mask-close>
			<div style="padding: .4rem 0;">
				<div class="pay-code flex-center">
					<img v-if="payInfo.offline_pay_config" :src="payInfo.offline_pay_config.qr_code_url" alt="">
				</div>
				<p class="pay-code-tip">请买方客户扫码付款</p>
			</div>
		</c-dialog>
	</div>
</template>

<script>
	export default {
		name: 'offlineOrderPay',

		props: {
			orderId: [String, Number, Array]
		},

		data() {
			return {
				sum: '-',
				payInfo: {},
				payNumber: '',
				currentPayMode: '',
				currentOfflinePayType: '',
				currentOnlinePayType: '',
				onlinePayCode: ''
			}
		},

		computed: {
			payModeOptions() {
				let options = [];
				if (this.payInfo.has_offline_pay) {
					options.push({name: '线下支付', value: 'offline'});
				}
				if (this.payInfo.has_online_pay) {
					options.push({name: '线上支付', value: 'online'});
				}
				return options;
			},

			offlinePayTypeOptions() {
				return this.payInfo.offline_pay_channels.map(item => {
					return {
						name: item.name,
						value: item.code
					}
				})
			},

			onlinePayTypeOptions() {
				return this.payInfo.online_pay_channels.map(item => {
					return {
						name: item.name,
						value: item.code
					}
				})
			}
		},

		watch: {
			currentPayMode(val) {
				if (val) {
					if (val == 'offline') {
						this.currentOfflinePayType = this.offlinePayTypeOptions[0].value;
						this.currentOnlinePayType = '';
						this.checkPayStatus(false);
					} else {
						this.currentOnlinePayType = this.onlinePayTypeOptions[0].value;
					}
				}
			},

			currentOnlinePayType(val) {
				if (val) {
					this.onlinePayCode = '';
					this.checkPayStatus(false);
					this._checkRequest = this.request({
						url: '/offline/sale/order/unionPay',
						data: {
							order_ids: Array.isArray(this.orderId) ? this.orderId : [this.orderId]
						},
						success: data => {
							this.payNumber = data.pay_trade_number;
							this._checkRequest = this.request({
								url: '/allinpay/collect/apply',
								data: {
									pay_trade_number: this.payNumber,
									pay_method: val
								},
								success: data => {
									if (data.payInfo) {
										this.onlinePayCode = data.payInfo;
										this.checkPayStatus();
									} else {
										this.$message({
											message: '生成二维码失败'
										});
									}
								}
							})
						}
					});
				}
			}
		},

		beforeDestroy() {
			this.closeHandle();
		},

		methods: {
			open() {
				this.currentPayMode = '';
				this.currentOfflinePayType = '';
				this.currentOnlinePayType = '';
				this.request({
					url: '/offline/sale/order/unionPay',
					data: {
						order_ids: Array.isArray(this.orderId) ? this.orderId : [this.orderId]
					},
					success: data => {
						this.sum = data.total_amount;
						this.payInfo = data;
						this.payNumber = data.pay_trade_number;
						this.currentPayMode = this.payModeOptions[0].value;
						this.$refs.pay.open();
					}
				});
			},

			checkPayStatus(state = true) {
				this._checkRequest && this._checkRequest.abort();
				clearTimeout(this._checkTimer);
				if (state) {
					this._checkRequest = this.request({
						url: '/allinpay/collect/query',
						data: {
							pay_trade_number: this.payNumber
						},
						success: data => {
							if (data.status == 2) {
								this.$refs.pay.close();
								this.$emit('resolve');
							} else {
								this._checkTimer = setTimeout(this.checkPayStatus, 1000);
							}
						}
					});
				}
			},

			submitHandle() {
				this.$refs.form.submit({
					url: '/offline/sale/order/pay',
					dataFormatter: data => {
						return Object.assign({
							pay_trade_number: this.payNumber,
							pay_method: this.currentPayMode == 'offline' ? this.currentOfflinePayType : ''
						}, data);
					},
					success: () => {
						this.$refs.pay.close();
						this.$emit('resolve');
					}
				})
			},

			closeHandle() {
				this.checkPayStatus(false);
				this.$emit('cancel');
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.pay {
		&-sum {
			height: 1rem;
			padding-top: .32rem;
			font-size: .32rem;

			strong {
				font-size: .6rem;
				color: #F70000;
			}
		}

		&-account {
			border-radius: .08rem;
			padding: .2rem .24rem;
			background: #F5F5F5;

			p {
				line-height: .42rem;
				font-size: .26rem;

				label {
					color: #666;
				}
			}
		}

		&-code {
			box-sizing: border-box;
			width: 5.4rem;
			height: 5.4rem;
			border-radius: .2rem;
			padding: .3rem;
			margin: .32rem auto 0;
			background: var(--color-main);

			img {
				border-radius: .12rem;
			}

			&-tip {
				line-height: .9rem;
				font-size: .32rem;
				text-align: center;
				color: #f55;
			}
		}
	}
</style>